import { useEffect } from 'react';

import { captureScrollForAuth } from '../utils/preserveScrollDuringAuth';

export const usePreserveScrollDuringAuth = (enabled = true): void => {
  useEffect(() => {
    if (!enabled) return;

    captureScrollForAuth();

    window.addEventListener('scroll', captureScrollForAuth, { passive: true });
    return () => window.removeEventListener('scroll', captureScrollForAuth);
  }, [enabled]);
};
